var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(_vm.$t("BusinessStockDistributionPlanView.title")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.isView
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm("form")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("okText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? _c("el-button", { on: { click: _vm.cancel } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ])
                : _vm._e(),
              _vm.isView && _vm.$route.query.isVerify
                ? [
                    _vm.info.status == "wait"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onStatus("pass")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("approvedText")))]
                        )
                      : _vm._e(),
                    _vm.info.status == "wait"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.onStatus("reject")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("auditRejectText")))]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "gray",
          staticStyle: { width: "500px" },
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("BusinessStockDistributionPlanView.code"),
                        prop: "code",
                      },
                    },
                    [
                      _c("BjInputCode", {
                        attrs: { disabled: _vm.isView },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionPlanView.receiveWarehouseId"
                        ),
                        prop: "receiveWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: {
                          disabled: _vm.isView,
                          "type-code": [
                            "default-virtual",
                            "qty-virtual",
                            "interline-virtual",
                          ],
                        },
                        on: {
                          change: _vm.onChangeWarehouse,
                          clear: _vm.onClear,
                        },
                        model: {
                          value: _vm.form.receiveWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiveWarehouseId", $$v)
                          },
                          expression: "form.receiveWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("form.startDateText"),
                        prop: "startDate",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          type: "datetime",
                          disabled: _vm.isView,
                          format: "dd/MM/yyyy HH:mm:ss",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("chooseText"),
                          "picker-options": _vm.$disabledPickerDate(),
                        },
                        on: { change: _vm.handleChangeStartTime },
                        model: {
                          value: _vm.form.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startDate", $$v)
                          },
                          expression: "form.startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("form.endDateText"),
                        prop: "endDate",
                      },
                    },
                    [
                      _c("BjDateTimerPicker", {
                        staticClass: "full-width",
                        attrs: {
                          placeholder: _vm.form.startDate
                            ? _vm.$t("chooseText")
                            : _vm.$t(
                                "BusinessStockDistributionPlanView.selectTime"
                              ),
                          disabled: _vm.isView || !_vm.form.startDate,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "start-time": _vm.form.startDate,
                        },
                        model: {
                          value: _vm.form.endDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endDate", $$v)
                          },
                          expression: "form.endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionPlanView.priority"
                        ),
                        prop: "priorityGrade",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: { disabled: _vm.isView },
                        model: {
                          value: _vm.form.priorityGrade,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priorityGrade", $$v)
                          },
                          expression: "form.priorityGrade",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.remarkText"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: _vm.isView,
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u(
            [
              !_vm.isView
                ? {
                    key: "button",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogListGoodsShow()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessStockDistributionPlanView.addingGoods"
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: {
                              disabled: _vm.selectedRow.length == 0,
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onDelSelected()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessStockDistributionPlanView.delGoods"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("BusinessStockDistributionPlanView.commodityDetails")
            ) + " "
          ),
        ]
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.form.detailList,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          !_vm.isView
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuName",
              label: _vm.$t("goodsPage.skuName"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              label: _vm.$t("goodsPage.skuCode"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inStockNum",
              width: "220",
              label: _vm.$t(
                "BusinessStockDistributionPlanView.table.inStockNum"
              ),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inStockUsableNum",
              width: "160",
              label: _vm.$t(
                "BusinessStockDistributionPlanView.table.inStockUsableNum"
              ),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "stockOutNum",
              width: "160",
              label: _vm.$t(
                "BusinessStockDistributionPlanView.table.stockOutNum"
              ),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "planNum",
              width: "220",
              label: _vm.$t("BusinessStockDistributionPlanView.table.planNum"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjInputNumber", {
                      attrs: { disabled: _vm.isView },
                      model: {
                        value: props.row.planNum,
                        callback: function ($$v) {
                          _vm.$set(props.row, "planNum", $$v)
                        },
                        expression: "props.row.planNum",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "priorityReplenishStatus",
              width: "230",
              label: _vm.$t(
                "BusinessStockDistributionPlanView.table.priorityReplenishStatus"
              ),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjSelectLov", {
                      attrs: {
                        disabled:
                          _vm.isView ||
                          props.row.stockOutNum == 0 ||
                          _vm.form.typeCode != "qty-virtual",
                        "option-list": _vm.STATUS_YES_TRUE,
                      },
                      model: {
                        value: props.row.priorityReplenishStatus,
                        callback: function ($$v) {
                          _vm.$set(props.row, "priorityReplenishStatus", $$v)
                        },
                        expression: "props.row.priorityReplenishStatus",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.operationText"),
              width: "140",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    (_vm.form.typeCode == "qty-virtual" ||
                      _vm.form.receiveWarehouseTypeCode == "qty-virtual") &&
                    props.row.stockOutNum > 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              disabled: props.row.planNum <= 0,
                              text: _vm.$t(
                                "BusinessStockDistributionPlanView.text"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onAllot(props.row, props.$index)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessStockDistributionPlanView.backorderAllocation"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", disabled: _vm.isView },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(props.row, props.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: {
          config: _vm.dialogListConfigGoods,
          multiple: "",
          "row-keys": "skuCode",
        },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
      _c("DialogStockoutOrderAllot", {
        ref: "allotRef",
        attrs: { "is-view": _vm.isView, "is-edit": _vm.isEdit },
        on: { confirm: _vm.getStockoutOrderAllotData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }